<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Uyguluma Takip Ekranı</h1>
          </div>

          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item"
                ><a>Anasayfa</a></router-link
              >
              <router-link tag="li" to="/watch" class="breadcrumb-item"
                ><a>Uygulamalar</a></router-link
              >
              <li class="breadcrumb-item active">Takip Ekranı</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header card-title">
                Uygulama Logları ( {{ app.name }} )
              </div>
              <div class="card-body table-responsive p-0" style="height: 650px">
                <table class="table table-striped projects">
                  <thead>
                    <!-- <tr>
                      <th colspan="3" :class="TotalBG">
                        Bekleyen İstek Sayısı : {{ ping.total }}
                      </th>
                      <th colspan="1" :class="PingBG">
                        Son Ping Zamanı : {{ ping.date | DateFormat }}
                      </th>
                    </tr> -->
                    <tr>
                      <th style="width: 1%">#</th>
                      <th>Uygulama Logu</th>
                      <th>Müşteri ID</th>
                      <th>Talep ID</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="datas.length == 0">
                      <td colspan="4" class="total-text text-center">
                        <b>Bekleyen Talep Bulunmuyor</b>
                      </td>
                    </tr>
                    <tr
                      v-for="(item, index) in datas"
                      :key="index"
                      :class="{ 'bg-danger': item.isError }"
                    >
                      <td>#</td>
                      <td>
                        <a> {{ item.context }} </a>
                        <br />
                        <small
                          ><b> İşlem Zamanı : {{ item.date | DateFormat }}</b>
                        </small>
                      </td>
                      <td>{{ item.customer }}</td>
                      <td>{{ item.bonus }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer"></div>
            </div>

            <!-- /.card -->
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</template>

<script>
export default {
  data() {
    return {
      id: this.$route.params.id,
      APP_APPLOG_API : process.env.VUE_APP_APPLOG_API,
      site: this.$store.getters.getSite,
      datas: [],
      app: [],
      ping: {
        date: "",
        total: 0,
        status: true,
        last: new Date()
      },
      timeout: null,
      intervalId:null,
      service: this.$store.getters.getHub
    };
  },
  computed: {
    TotalBG() {
      if (this.ping.total <= 10) return "bg-success";
      else return "bg-danger";
    },
    PingBG() {
      this.ping.last = new Date(
        this.ping.last.setTime(this.ping.last.getTime() - 2 * 60 * 1000)
      );
      if (new Date(this.ping.date) > this.ping.last) return "bg-success";
      else return "bg-danger";
    }
  },
  methods: {
    getDatas() {
      //this.$store.dispatch("getLogListService", this.$route.params.id);
      this.fetchData();
        this.intervalId = setInterval(() => {
          this.fetchData();
        }, 5000);
    },
    fetchData() {
      this.$http.post(`${this.APP_APPLOG_API}/list`, {
        "request_row_count": 100,
        "site_name": this.site,
        "app": this.$route.params.id
      }).then(response => {
        console.log(response);
        this.datas = response.data.data;
      });
    },
    getApp() {
      this.$http
        .get("AppProcess/GetAppProcess/" + this.$route.params.id)
        .then(response => {
          this.app = response.data;
          this.$store.commit("setWatchPing", this.app.pingDate);
        });
    },
    resetPage() {
      this.getDatas();
      this.getApp();
    }
  },
  filters: {
    DateFormat(value) {
      if (!value) return "Giriş Yapılmamış";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    }
  },

  created() {
    // this.$store.commit("clearLogList");
    // this.$store.commit("setBotLogId", this.$route.params.id);
    this.getApp();
    this.getDatas();
    this.timeout = setInterval(() => {
      this.ping.last = new Date();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timeout);
    clearInterval(this.intervalId);
  },
  watch: {
    // "$store.getters.getBotList"() {
    //   const status = this.$store.getters.getBotStatus;
    //   this.ping.date = status.date;
    //   this.ping.total = status.total;
    //   this.datas = this.$store.getters.getLogList;
    // },
    // "$store.getters.getLogList"() {
    //   this.datas = this.$store.getters.getLogList;
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Watch/WatchLog.vue